import { useTolgee, useTranslate } from '@tolgee/react';
import React, { useState } from 'react';
import Logo from '../../assets/images/Logo.png';
import './Header.scss'; // Import your CSS file for styling

import Login from '../../pages/login/Login';

import { Layout } from 'antd';
import classNames from 'classnames';
import {
  useGlobalActions,
  useGlobalContext,
} from '../../global-context/GlobalContext';
import { useEffectOnce } from '../../hooks/utils/useEffectOnce';
import useIsMobile from '../../hooks/utils/useIsMobile';
import localStorageService from '../../services/LocalStorage';
import { changeLanguageGraphQL } from '../../utils/graphqlClient';
import DrawerCommon from '../common/drawer-common/DrawerCommon';
import { RemarksDrawer } from '../common/remarks-drawer/RemarksDrawer';
type HeaderProps = {
  isSignedIn: boolean; // Prop to check if user is signed in
};
const languages = [
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
  { code: 'de', label: 'DE' },
];
const Header: React.FC<HeaderProps> = ({ isSignedIn }) => {
  const [signUpVisible, setSignUp] = useState(false);
  const isMobile = useIsMobile();
  const { setIsSidePanelOpen } = useGlobalActions();

  const { t } = useTranslate();
  const isSidePanelOpen = useGlobalContext(c => c.app.isSidePanelOpen);

  return (
    <Layout.Header className={classNames('header')}>
      <DrawerCommon
        isVisible={!isSignedIn && signUpVisible}
        placement='left'
        setVisibility={setSignUp}
      >
        <Login
          closePopup={() => {
            setSignUp(false);
          }}
        />
      </DrawerCommon>
      <div
        className={classNames('header-container', {
          'sign-in': isSignedIn,
          'sidebar-open': isSidePanelOpen && !isMobile,
          mobile: isMobile,
        })}
      >
        {isMobile && !isSidePanelOpen && isSignedIn && (
          <button
            className='hamburger-icon'
            aria-label='menu'
            onClick={() => {
              setIsSidePanelOpen(e => !e);
            }}
          >
            &#9776;
          </button>
        )}
        <div className='left-section'>
          {isSignedIn ? null : (
            <button
              className='sign-up-button'
              onClick={() => {
                setSignUp(true);
              }}
            >
              {t('log-in')}
            </button>
          )}
        </div>
        <div
          className={classNames('center-section', {
            mobile: isMobile && isSignedIn,
          })}
        >
          <img src={Logo} alt='Company Logo' className='logo' />
        </div>
        <div className='right-section'>
          <span className={classNames('remarks-drawer', { mobile: isMobile })}>
            <RemarksDrawer />
          </span>

          <span className='language-selector'>
            <LanguageSelector />
          </span>
        </div>
      </div>
    </Layout.Header>
  );
};

const LanguageSelector: React.FC = () => {
  const { changeLanguage, getLanguage } = useTolgee();
  const [selectedLanguage, setSelectedLanguage] = useState(getLanguage());
  const t = useTranslate();

  useEffectOnce(() => {
    const setLang = localStorageService.getItem<string>('selectedLang') ?? 'en';
    changeLanguage(setLang);
    setSelectedLanguage(setLang);
    changeLanguageGraphQL(setLang);
  });

  return (
    <div>
      {languages.map(lang => (
        <span
          key={lang.code}
          style={{ marginLeft: '0.8rem' }}
          onClick={() => {
            changeLanguage(lang.code);
            localStorageService.setItem('selectedLang', lang.code);
            setSelectedLanguage(lang.code);
            changeLanguageGraphQL(lang.code);
          }}
        >
          <span
            className={classNames('language-label', {
              'language-selected': lang.code === selectedLanguage,
            })}
          >
            {lang.label}
          </span>
        </span>
      ))}
    </div>
  );
};

export default Header;
